import { Box, IconButton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const EmojiPickerContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  boxSizing: "border-box",
  width: 320,
  height: 340,
  maxWidth: "calc(100vw - 32px)",
  overflow: "hidden",
  padding: theme.spacing(1.5),
  gap: theme.spacing(1),
}));

export const EmojiPickerList = styled(Box)({
  flex: 1,
  minWidth: 0,
  minHeight: 0,
  overflowX: "hidden",
  overflowY: "auto",
});

export const EmojiPickerSectionTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: 12,
  fontWeight: 600,
  padding: theme.spacing(1, 0.5, 0.5),
  position: "sticky",
  top: 0,
  backgroundColor: theme.palette.background.paper,
  zIndex: 1,
}));

export const EmojiPickerGroup = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0.5),
}));

export const EmojiPickerGrid = styled(Box)({
  display: "grid",
  gridTemplateColumns: "repeat(8, minmax(0, 1fr))",
  gap: 2,
});

export const EmojiPickerButton = styled(IconButton)(({ theme }) => ({
  minWidth: 0,
  width: "100%",
  aspectRatio: "1 / 1",
  height: "auto",
  padding: 0,
  borderRadius: theme.shape.borderRadius,
  fontSize: 26,
  lineHeight: 1,
  // IconButton defaults to action.active (54% black), which fades color emoji.
  color: theme.palette.common.black,
  fontFamily:
    '"Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", sans-serif',
}));
